import { urlEncodeB64 } from "./urlEncodeB64";

export async function generateChallenge(verifier: string): Promise<string> {
    const encoder = new TextEncoder();
    const data = encoder.encode(verifier);
    const hashBuffer = await crypto.subtle.digest("SHA-256", data);
    const base64 = btoa(String.fromCharCode(...new Uint8Array(hashBuffer)));
    return urlEncodeB64(base64);
}
